import * as React from "react";
import { useEffect } from "react";
import "./searchViewStyles.css";
import { focusManager } from "../../../utils/Focus";
import { SearchKeyboardKeyView } from "./SearchKeyboardKeyView";
export var SearchKeyboardView = function (_a) {
    var keyboard = _a.keyboard, onKeyPress = _a.onKeyPress, keyboardLang = _a.keyboardLang, verticalContainer = _a.verticalContainer;
    useEffect(function () {
        Object.values(keyboard).map(function (row, i) {
            focusManager.registerGroup({
                name: "key-" + keyboardLang + "-" + i,
                position: 10,
                verticalContainer: verticalContainer,
            });
        });
    }, [focusManager, keyboard, keyboardLang, verticalContainer]);
    return (React.createElement("div", { className: "keyboard" }, Object.values(keyboard).map(function (row, i) { return (React.createElement("div", { key: i, id: "keyboard-row-" + i, className: "keyboard-row" }, row.map(function (key, index) {
        var className = "key";
        if (key === "⌫")
            className += " key-clear";
        if (key === " ")
            className += " key-space-" + keyboardLang;
        if (key === "🌐")
            className += " key-globe";
        return (React.createElement(SearchKeyboardKeyView, { key: index, focusRaw: ["key-" + keyboardLang + "-" + i, index], keyText: key, onKeyPressHandle: onKeyPress, className: className }));
    }))); })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/search/SearchKeyboardView.tsx
// module id = 166
// module chunks = 1